export const PLAYER_A = '#275db1';
export const PLAYER_B = '#ff252f';
export const PUSH = '#46a647';

export const SIDEBET = '#9CA8C2';

export const OPACITY_LOW = 0.65;
export const OPACITY_HIGH = 0.85;
